import React, { useContext, useLayoutEffect } from 'react';
import { styled } from 'styled-components';
import Text from '@ingka/text';
import { useTranslation } from 'react-i18next';
import SVGAlien from '../assets/alien.svg';
import { getAppViewQueryParams } from '../helpers/appViewHelper';
import PageTitle from '../components/PageTitle';
import StickyHeader from '../components/StickyHeader';
import RedirectButton from '../components/RedirectButton';
import { ViewContext } from '../context';

const PrevButton = styled(RedirectButton)`
  width: 48%;
  max-width: 234px;
`;

const StyledCentered = styled.div`
  display: flex;
  flex-flow: column;
  text-align: center;
  align-items: center;
`;

const ServiceUnavailablePage: React.FC = () => {
  const { t } = useTranslation();
  const view = useContext(ViewContext);
  const { redirectUrl } = getAppViewQueryParams();
  const isViewAlt = view === 'alt';

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <PageTitle title={t('pages.serviceUnavailable.pageTitle')} />
      {isViewAlt && <StickyHeader />}
      <StyledCentered>
        <img
          src={SVGAlien}
          height={400}
          alt={t('pages.serviceUnavailable.title')}
          data-cy="service-unavailable-img"
        />

        <Text
          data-cy="service-unavailable-title"
          tagName={isViewAlt ? 'h2' : 'h1'}
          textStyle="Heading.L"
        >
          {t('pages.serviceUnavailable.title')}
        </Text>
        <Text
          data-cy="service-unavailable-description"
          tagName="p"
          textStyle="Body.L"
        >
          {t('pages.serviceUnavailable.description')}
        </Text>
        {redirectUrl && view === 'app' && (
          <PrevButton
            url={`${redirectUrl}?status=cancel`}
            label={t('pages.serviceUnavailable.mobileBackBtnText')}
            dataCy="previous-btn"
          />
        )}
      </StyledCentered>
    </>
  );
};
export default ServiceUnavailablePage;
